import { init as initHelpers } from './helpers';
import { initCsrfRefresh } from './shared/csrf-token.js';

initCsrfRefresh();
initHelpers();
